import { createContext } from "react";

type BerthData = {
  berthName: string;
  berthType: string | null;
};

type BerthDataContextType = {
  berthData: BerthData;
  updateBerthData: (newData: Partial<BerthData>) => void;
};

export const BerthDataContext = createContext<BerthDataContextType>({
  berthData: { berthName: "", berthType: "" },
  updateBerthData: () => {},
});
